import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Message2 = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M8.5 18.9492H8C4 18.9492 2 17.9521 2 12.9671V7.98205C2 3.99402 4 2 8 2H16C20 2 22 3.99402 22 7.98205V12.9671C22 16.9551 20 18.9492 16 18.9492H15.5C15.19 18.9492 14.89 19.0987 14.7 19.348L13.2 21.342C12.54 22.2193 11.46 22.2193 10.8 21.342L9.3 19.348C9.14 19.1286 8.77 18.9492 8.5 18.9492Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <rect x='2' y='2' width='20' height='17' rx='5' fill='currentColor' />
        <path
          d='M8.5 19C8.77 19 9.13 19.1801 9.3 19.4002L10.8 21.3912C11.46 22.2716 12.54 22.2716 13.2 21.3912L14.7 19.4002C14.89 19.1501 15.19 19 15.5 19H8.5Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
